import React from "react";
import classNames from "classnames";

import aStyles from "./appnavbar.module.scss";
import { Link } from "react-router-dom";

const AppNavigationAction = (props) => {
  const { title, icon, isSelected, to, classIcon } = props;

  const titleClass = classNames("semibold", "actionTitle");
  const iconContainerClass = classNames(
    aStyles.iconContainer,
    isSelected ? aStyles.selected : aStyles.iconContainer.selected
  );
  const ariaCurrentPageLabel = isSelected ? "page" : undefined;
  return (
    <div className={aStyles.action}>
      <Link
        className={aStyles.actionButton}
        aria-label={title}
        to={to}
        aria-current={ariaCurrentPageLabel}
      >
        <div data-testid={"icon-container"} className={iconContainerClass}>
          <i
            className={classNames(
              `tg-icons-${icon} ${aStyles.iconSize}`,
              classIcon
            )}
          ></i>
        </div>
        <span className={titleClass}>{title}</span>
      </Link>
    </div>
  );
};

export default AppNavigationAction;
